<script lang="ts">
import Vue from 'vue';
import CsrBanner from './sections/CsrBanner.ts.vue';
import CsrWhy from './sections/CsrWhy.ts.vue';
import CsrWhat from './sections/CsrWhat.ts.vue';
import CsrProjects from './sections/CsrProjects.ts.vue';
import CsrPartners from './sections/CsrPartners.ts.vue';
import CsrHow from './sections/CsrHow.ts.vue';
import CsrContact from './sections/CsrContact.ts.vue';

export default Vue.extend({
  render(h) {
    const items = [
      CsrBanner,
      CsrWhy,
      CsrWhat,
      CsrProjects,
      CsrPartners,
      CsrHow,
      CsrContact,
    ];

    return h(
      'article',
      items.map((item, index) => h(item, {
        props: {
          useAlternateBgColor: index % 2 === 1,
        },
      })),
    );
  },
});
</script>
